export default __webpack_public_path__ + "static/media/49.1a03c146.gif";